// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xmPvF4jdMtgPpKk9U1PE {
  border-color: #ff0000 !important;
  color: #c2cfff !important;
}

.IDT5sZnW4HgVDOZ8kjRc {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #666666 !important;
}

.ltd1PX2onb_70YgcXu4Q {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #333333;
}

.WBzU0LlF0bACyAO2nNBK {
  padding: 5px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `xmPvF4jdMtgPpKk9U1PE`,
	"normal": `IDT5sZnW4HgVDOZ8kjRc`,
	"placeholder": `ltd1PX2onb_70YgcXu4Q`,
	"searchIcon": `WBzU0LlF0bACyAO2nNBK`
};
export default ___CSS_LOADER_EXPORT___;
